<template>
    <div class="notice-content">
        <car-headerbar title="模版设置" :isCustomLeft="isCustomLeft"/>
        <me-cell-group class="defined-group">
            <me-field
                ref="input"
                v-model="templateName"
                input-align="right"
                maxlength="50"
                required
                label="模板名称"
                @blur="templateNameChange"
                placeholder="请输入模板名称"/>
                <me-cell class="defined-cell" style="margin-bottom: 0px;" title="可查看范围" :value="haveRange ? '已设置' : '未设置'" @click.prevent="jump('sendingRange')" is-link/>
                <me-cell class="defined-cell" title="标签" :value="haveLabel ? '已设置' : '未设置'" is-link @click.prevent="jump('customLabel')"/>
        </me-cell-group>
        <confirm
            @confirm="confirm"
            cancelText="取消"
            text="确定"
        />
    </div>
</template>
<script>

import { addClass2, removeClass2 } from '@/util/status-util'
import { Toast } from '@guazi-fe/melon'
import confirm from '../../compontents/confirm.vue'
import { Cell, CellGroup} from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import browser from '@/util/browser'
import { Dialog } from '@guazi-fe/melon'

export default {
    name: 'publish',
    data() {
        return {
            dialogShow: false,
            dialogMsg: '',
            showBtn: false,
            signOptions: [],
            haveLabel: false,
            haveRange: false, // 发送范围
            isCustomLeft: false,
            templateName: ''
        }
    },
    mixins: [mixin],
    components: { 
        confirm, 
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        query() {
            return this.$route.query
        },
        requestData() {
            return {
                tid: this.tid,
                pageId: this.pageId,
            }
        },
    },
    created() {
        this.handlePublishData()
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
    },
    mounted() {
        // if (/Android/gi.test(navigator.userAgent)) {
        //     // 如果是安卓用户，则需要做处理
        //     NativeApi.register('back', (data, responseCallback) => {
        //         responseCallback('{preventDefault: true}') // 阻止默认返回事件
        //         this.back()
        //     })
        // } else {
        //     NativeApi.register('back', (data, responseCallback) => {
        //         responseCallback({ 'preventDefault': true }) // 阻止默认返回事件
        //         this.back()
        //     })
        // }
    },
    methods: {
        templateNameChange(value) {
            sessionStorage.setItem('templateName', this.templateName)
        },
        queryConfig() {
            addClass2('body', 'loading')
            const params = {
                tid: this.tid,
                pageTempId: this.pageId,
            }
            Questionnaire.queryConfig(params).then((res) => {
                const { code, data } = res.data
                removeClass2('body', 'loading')
                if (code == 'S00000') {
                    if (data.labelNames.length > 0) this.haveLabel = true
                    if (data.sendRangeConfigs.length > 0) this.haveRange = true
                    let templateName = sessionStorage.getItem('templateName')
                    this.templateName = templateName || data.templateName || ''
                    this.$store.commit('saveRangeList', data.sendRangeConfigs)
                    let templateData = {
                        pageId: this.pageId,
                        templateName: this.templateName,
                        sheetShow: false,
                    }
                    this.$store.commit('updateLabelNames', data.labelNames)
                    this.$store.commit('updateTemplateData', templateData)
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        dialogCancel() {
            this.$store.commit('removeRangeList')
            this.$store.commit('removePublishData')
            this.$router.push({
                name: 'mine'
            })
        },
        handlePublishData() {
            if (this.query.updateRange == 1 || this.query.updateLabel == 1) {
                this.templateName = this.$store.state.templateData.templateName
                if (this.$store.state.rangeList.length > 0) {
                    this.haveRange = true
                } else {
                    this.haveRange = false
                    this.$store.commit('removeRangeList')
                }
                if (this.$store.state.labelNames.length > 0) {
                    this.haveLabel = true
                } else {
                    this.haveLabel = false
                    this.$store.commit('updateLabelNames', [])
                }
                removeClass2('body', 'loading')
            } else {
                this.$store.commit('removeTemplateData')
                this.$store.commit('removeRangeList')
                this.$store.commit('updateLabelNames', [])
                this.queryConfig()
            }
        },
        jump(name) {
            let templateData = {
                pageId: this.pageId,
                templateName: this.templateName,
                sheetShow: false,
            }
            this.$store.commit('updateTemplateData', templateData)
            this.$router.push({
                name,
                params: {
                    pageId: this.pageId,
                },
                query: {
                    updateRange: this.query.updateRange || '0',
                    updateLabel: this.query.updateLabel || '0',
                    templateSetting: '1'
                }
            })
        },
        confirm() {
            addClass2('body', 'loading')
            let sendRangeConfigs = this.$store.state.rangeList
            let labelNames = this.$store.state.labelNames
            let data = {
                tid: this.tid,
                pageTempId: this.pageId,
                sendRangeConfigs,
                templateName: this.templateName,
                labelNames
            }
            Questionnaire.editTemplate(data).then((res) => {
                removeClass2('body', 'loading')
                this.$store.commit('removeTemplateData')
                this.$store.commit('removeRangeList')
                this.$store.commit('updateLabelNames', [])
                this.$router.push({
                    name: 'template',
                    query: {
                        active: '1'
                    }
                })
            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            })
        },
    },
}
</script>
<style scoped lang="scss">
    .defined-span {
        padding: 0.26667rem 0.42667rem;
        font-size: 0.31rem;
    }
    .dialog_msg {
        padding: 14px;
        text-align: center;
    }
    .notice-content{
        padding-bottom: 2.66667rem;
        .types{
            display: flex;
            justify-content: space-between;
            margin: 0.3rem .53rem;
        }
        .content{
            padding: .42rem;
            font-size: 0.37333rem;
            background: #fff;
            .texts{
                margin: .4rem 0;
                display: flex;
                justify-content: space-between;
                >span{
                    cursor: pointer;
                    text-decoration: underline;
                    color: #06B455;
                }
            }
            .tip{
                margin-top: .5rem;
                margin-bottom: .2rem;
                color: rgba(69, 90, 100, 0.6);
                font-size: .32rem;
                &::before{
                    content: '';
                    display: inline-block;
                    margin-right: .1rem; 
                    width: .32rem;
                    height: .32rem;
                    background: url(../../images/warning.png) no-repeat;
                    background-size: cover;
                    vertical-align: -.03rem;
                }
                // >span{
                //     color: #2c3e50;
                // }
            }
            .send-tip{
                text-decoration: underline;
                .info-o{
                    vertical-align: -.08rem;
                    font-size: .43rem;
                    margin-right: .1rem;
                }
            }
        }
        .not-yet{
            opacity: 0;
        }
    }
    .dialog-content{
        padding: .3rem;
        .import-btn{
            display: inline-block;
            padding: 0.2rem 0.5rem;
            width: 2.6rem;
            border: 0.02667rem solid #06B455;
            border-radius: 0.1rem;
            font-size: 0.37rem;
            box-sizing: border-box;
            text-align: center;
        }
        .down{
            margin-left: 1rem;
            color: #06B455;
            text-decoration: underline;
            font-size: .37rem;
        }
        .notice{
            display: flex;
            font-size: .32rem;
            margin: 0.6rem 0 .2rem;
            color: #5F6670;
        }
        .file{
            margin-bottom: .6rem;
            display: flex;
            justify-content: space-between;
            font-size: 0.37rem;
            .fileName{
                flex: 1;
            }
            .del{
                display: inline-block;
                margin-left: .5rem;
                width: 1rem;
                text-decoration: underline;
            }
        }
    }
    .defined-group{
        &:after{
            border-top: none;
        }
    }
    .defined-cell{
        margin-bottom: 10px;
        i[class^="me-icon"]{
            top: 5px;
        }
    }
    ::v-deep .me-cell:not(.defined-cell){
        padding: 10px 16px;
        height: 41px;
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    ::v-deep .me-field__body{
        border-radius: .1rem;
        background: #F6F6F6;
    }
    ::v-deep .me-field__control{
        background-color: #fff;
    }
</style>
